const { createSlice } = require("@reduxjs/toolkit")

const initialState = {
    username: "",
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUsername: (state, action) => {
            state.username = action.payload;
        },
        clearUsername: (state) => {
            state.username = "";
        }
    }
});

export const {setUsername, clearUsername} = userSlice.actions;
export const selectUsername = (state) => state.user.username;

export default userSlice.reducer;